// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tj","articleImagesWrap":"Uj","articleImage":"Vj","singleImage":"Wj"};